import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    initializing: true, // 初始化
    configFinding: false, // 配置查找中
    selectedUnitIds: null,
    unitsMap: null,

    tableTitles: null, // 表格head数据
    tableLoading: false, // 表格数据加载
    tableData: null, // 表格数据
    res: null, // 接口请求到的数据

    // 点击单元格
    detailDrawerVisible: false, // 详情可见
    detailDrawerData: null, // 详情数据
    detailDrawerLoading: false, // 详情加载
    clickedCell: {
        unitId: null, // 点击查看详情的科室
        option: null, // 点击查看详情的字典
        category: null, // 点击查看详情的分类
        title: null, // 点击查看详情的标题
    },

    showEmpty: false, // 显示未填
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
